import * as rq from '@tanstack/react-query';
import { z } from 'zod';

import { SiteSchema } from '../entities/site';

import { getSites } from './__mocked_data__/sites-state';

export namespace GetSitesQuery {
  export const key = () => ['user-management', 'sites'];

  export const OutputSchema = z.object({
    sites: z.array(
      SiteSchema.pick({
        id: true,
        fullFrontendId: true,
      }),
    ),
  });
  export type Output = z.infer<typeof OutputSchema>;

  function outputMapper(): Output {
    const result = getSites();

    return result;
  }

  function useQueryFn() {
    return async function queryFn() {
      const output = await OutputSchema.parseAsync(outputMapper());
      return output;
    };
  }

  export function useQuery() {
    const queryFn = useQueryFn();

    return rq.useQuery<Output>({
      queryKey: key(),
      queryFn: () => queryFn(),
      keepPreviousData: true,
    });
  }

  export function usePrefetch() {
    const queryClient = rq.useQueryClient();
    const queryFn = useQueryFn();

    return async function prefetch(): Promise<void> {
      await queryClient.prefetchQuery<Output>({
        queryKey: key(),
        queryFn: () => queryFn(),
      });
    };
  }
}
